import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { toastBodyStyles } from './styles/toast-body.styles';
import type { ToastBodyPropsInterface } from './types/toast-body.types';

export const ToastBody = forwardRef<HTMLDivElement, ToastBodyPropsInterface>(
  (props: ToastBodyPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const styles = css(toastBodyStyles, cssProp);

    return (
      <div
        className={cx('c11n', styles, className)}
        data-c11n-component="Toast.Body"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

ToastBody.displayName = 'Toast.Body';
